import Vue from 'vue'
import dialog from './dialog'
import {getPage} from '@/pages'
import {getSyncText} from '@/utils/rest'
/**
 * 对话框管理
 * @author Paul.Yang E-mail:yaboocn@qq.com
 * @version 1.0 2017-7-18
 */
let dialogId = 0
export default {
  render: function (createElement) {
    let options = this.$options
    function createDialog (d) {
      let {props, text, html, component, params, dialog, container} = d
      let tagName = 'custom-dialog'
      if (container) {
        if (typeof container === 'string') {
          let name = tagName = container.replace('/', '_')
          if (!options.components[name]) {
            options.components[name] = getPage(container)
          }
        } else {
          let name = tagName = container.name || container.toString()
          if (!options.components[name]) {
            options.components[name] = container
          }
        }
      }
      // 这是调用dom 的方法吗
      return createElement(tagName, {props: {dialogProps: props, component, text, html, params, dialog}})
    }
    let dialogs = this._dialogs
    // resolve props
    return createElement('div', null, dialogs.map((d, i) => {
      return createDialog(d)
    }))
  },
  props: {
    // ...
  },
  components: {
    'custom-dialog': dialog
  },
  created () {
    let $dialogs = this
    this._dialogQueue = []
    Vue.util.defineReactive(this, '_dialogs', [])
    function showDialog (component) {
      $dialogs.show(component)
    }
    Vue.prototype.$showDialog = showDialog
    Object.defineProperty(Vue.prototype, '$dialogs', {
      get () { return $dialogs }
    })
  },
  updated () {
    if (this.showing) {
      this.triggerOpen(this.showing)
      this.showing = undefined
    }
  },
  methods: {
    triggerOpen (dialog) {
      let f = dialog['@open']
      typeof f === 'function' && f()
    },
    show (component) {
      let dls = this._dialogs
      let cvn = this._vnode.children
      let $cvm = this.$children
      let cel = this.$el.children
      if (this.$el && this.$el.children.length > 0) {
        let count = 0
        $cvm.forEach(($e, i) => {
          if ($e.isVisible ? $e.isVisible() : cel[i].style.display !== 'none') {
            return
          }
          if (dls[i].dep && document.querySelector(dls[i].dep)) {
            // return
          }
          /* eslint-disable no-undef */
          $(cel[i]).remove()
          $cvm.splice(i - count, 1)
          dls.splice(i - count, 1)
          cvn.splice(i - count, 1)
          count++
        })
      }
      let dlg = component
      if (typeof component === 'string') {
        let path = component
        component = getPage(path)
        if (!component) {
          let text = getSyncText(path)
          dlg = {text}
        } else {
          dlg = {component}
        }
      } else if (typeof dlg.component === 'string') {
        dlg.component = getPage(dlg.component)
      }
      let len = dls.length
      if (dlg.component) {
        for (let i = len - 1; i >= 0; i--) {
          if (!dls[i].component) {
            continue
          }
          if (dls[i].component._dlgid === dlg.component._dlgid) {
            if (dlg.refresh) {
              /* eslint-disable no-undef */
              $(cel[i]).remove()
              $cvm.splice(i)
              dls.splice(i)
              cvn.splice(i)
            } else {
              this.$children[i].show()
              this.triggerOpen(dls[i])
              return
            }
          }
        }
      }

      if (dlg.component) {
        dlg.component._dlgid = dialogId++
      }
      dls.push(dlg)
      this.showing = dlg
      this._dialogs = dls
    },
    closeCurrent () {
      let c = this.getCurrent()
      if (c) {
        c.hide()
      }
    },
    getCurrent () {
      let $children = this.$children
      if ($children.length === 0) {
        return
      }
      for (let i = $children.length - 1; i >= 0; i--) {
        let c = $children[i]
        if (c.isVisible()) {
          return c
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/dialog/dialog-set.js